import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useModal, ModalImages, ModalButtons } from "context/modalContext";
import { authorizedGenApiCall } from "api/genApiCalls";

const useToolbarProps = ({ webPageKey }) => {
  const [columns, setColumns] = useState([]);
  const [pdfFiles, setPdfFiles] = useState([]);
  const [csvFiles, setCsvFiles] = useState([]);
  const [excelFiles, setExcelFiles] = useState([]);
  //   const [searchParams, setSearchParams] = useSearchParams();
  //   const [critParams, setCritParams] = useState(null);
  const [status, setStatus] = useState(false);

  // criteria Ref is used to save fetched Data in order to use them in Criteria Component
  // const criteriaRef = useRef([]);
  // const critId = searchParams.get('critId');
  const { openModal } = useModal();
  const navigate = useNavigate();

  useEffect(() => {
    async function fetchData() {
      try {
        const res = await authorizedGenApiCall({
          dataKey: "eShop-ExplorerToolbarData-Get",
          parameters: [{ dataKey: "webPageKey", dataValue: webPageKey }], //    , critId: critId ?? null
        });
        let parsedData = [];
        try {
          parsedData = JSON.parse(res?.data);
        } catch {
          parsedData = [];
        }

        const gridColumns = parsedData?.gridColumns;
        const pdf = parsedData?.rptPdf;
        const csv = parsedData?.rptCsv;
        const excel = parsedData?.rptExcel;

        // if (!searchParams.get('critId')) {
        //     setSearchParams({ critId: parsedData?.critId });
        // }

        // setCritParams(parsedData?.critParams);

        setPdfFiles(pdf ?? []);
        setCsvFiles(csv ?? []);
        setExcelFiles(
          excel
            ? [...excel, { rptId: "default", rptTitle: "Προεπιλογή" }]
            : [{ rptId: "default", rptTitle: "Προεπιλογή" }]
        );

        setColumns(gridColumns);
        // criteriaRef.current.critValuesList = parsedData?.critValuesList;
        // criteriaRef.current.critFldsSearch = parsedData?.critFldsSearch;
        setStatus(true);
      } catch {
        openModal({
          title: "Σφάλμα",
          message: "Δεν βρέθηκαν οι απαραίτητες παράμετροι.",
          imageType: ModalImages.Error,
          buttons: ModalButtons.Ok,
          callback: (command) => {},
        });
      }
    }
    fetchData();
  }, []);

  return {
    columns,
    pdfFiles,
    csvFiles,
    excelFiles,
    // criteriaRef,
    // critParams,
    status,
  };
};

export default useToolbarProps;
